import * as Yup from 'yup';

const SignUpStepOneSchema = Yup.object().shape({
  name: Yup.string().required('This field is required'),
  surname: Yup.string().required('This field is required'),
  country: Yup.string().required('This field is required'),
  email: Yup.string()
    .email('Invalid email address')
    .required('This field is required'),
  password: Yup.string()
    .min(8, 'Must be longer than 8 characters')
    .max(16, 'Must be less than 16 characters')
    .required('This field is required'),
  confirmPassword: Yup.string()
    .min(8, 'Must be longer than 8 characters')
    .max(16, 'Must be less than 16 characters')
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('This field is required'),
  agree: Yup.bool().oneOf([true], 'Field must be checked'),
});

export default SignUpStepOneSchema;
